import { jsx as n } from "react/jsx-runtime";
import { Content as r } from "./content/component.js";
const m = ({ size: t, className: o }) => /* @__PURE__ */ n(
  r,
  {
    className: o,
    height: t,
    width: t
  }
);
export {
  m as SendInOutlined
};
